
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningHeavyRainColour as ObiLightningHeavyRainColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-heavy-rain-colour.js';
 
 
 

 
 export const ObiLightningHeavyRainColour = createComponent({
   react: React,
   tagName: 'obi-lightning-heavy-rain-colour',
   elementClass: ObiLightningHeavyRainColourElement,
   events: {
     
   }
  });
 
 